import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Organisation } from '@futrli-sdk/organisations';
import { UpdateFromExcelModalContent } from '@futrli/shared-services/excel-upload';

import { useIntegrations } from '../../../../../../predict-management/hooks/useIntegrations';
import { OrganisationUploadDrawer } from '@futrli/shared-services/excel-upload/excel-modals/upload/organisation-upload-drawer';

interface UpdateFromExcelOrganisationModalProps {
  onClose: () => void;
  isOpen: boolean;
  organisation: Organisation;
  workspaceId: string;
}

export const UpdateFromExcelOrganisationDrawer = ({
  onClose,
  isOpen,
  organisation,
  workspaceId
}: UpdateFromExcelOrganisationModalProps) => {
  const integrations = useIntegrations();

  return (
    <OrganisationUploadDrawer
      title={
        <FormattedMessage
          id="predict.update_excel_data_for_name"
          defaultMessage="Update the excel data for {orgName}"
          values={{ orgName: organisation.name }}
        />
      }
      isOpen={isOpen}
      handleClose={onClose}
      workspaceId={workspaceId}
      excelIntegration={integrations?.find(integration => integration.slug === 'excel')}
      organisation={organisation}
      isUpdateDrawer
    >
      <UpdateFromExcelModalContent
        workspaceId={workspaceId}
        organisationId={organisation.id}
        config={{ entityType: 'organisation' }}
        guidelinesUrl="https://support.futrli.com/en/articles/10485548-excel-organisations"
      />
    </OrganisationUploadDrawer>
  );
};
